import { render } from "./Clinic.vue?vue&type=template&id=42185d36&scoped=true"
import script from "./Clinic.vue?vue&type=script&lang=js"
export * from "./Clinic.vue?vue&type=script&lang=js"

import "./Clinic.vue?vue&type=style&index=0&id=42185d36&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42185d36"]])

export default __exports__